/* eslint-disable camelcase */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BrainGames from './BrainGames';
import Surveillance from './Surveillance';
import phrasesType from '../../proptypes/phrases';
import useCompanionProfile from '../useCompanionProfile';

const pollingInterval = 5000;

const PlayableGames = ({
  companionProfile,
  hqSurveillancePath,
  hqGamesCompletePath,
  phrases,
}) => {
  const {
    companionProfile: {
      nextBrainGamePath,
      numberOfPlayedChallenges,
      numberOfRemainingChallenges,
      surveillanceComplete,
      allGamesComplete,
    },
  } = useCompanionProfile(companionProfile, pollingInterval);

  useEffect(() => {
    if (allGamesComplete) {
      window.location.replace(hqGamesCompletePath);
    }
  }, [allGamesComplete, hqGamesCompletePath]);

  return (
    <>
      <BrainGames
        nextBrainGamePath={nextBrainGamePath}
        numberOfPlayedChallenges={numberOfPlayedChallenges}
        numberOfRemainingChallenges={numberOfRemainingChallenges}
        phrases={phrases}
      />
      <Surveillance
        surveillanceComplete={surveillanceComplete}
        hqSurveillancePath={hqSurveillancePath}
        phrases={phrases}
      />
    </>
  );
};

PlayableGames.propTypes = {
  companionProfile: PropTypes.exact({
    nextBrainGamePath: PropTypes.string,
    numberOfPlayedChallenges: PropTypes.number.isRequired,
    numberOfRemainingChallenges: PropTypes.number.isRequired,
    surveillanceComplete: PropTypes.bool.isRequired,
    allGamesComplete: PropTypes.bool.isRequired,
  }).isRequired,
  hqSurveillancePath: PropTypes.string.isRequired,
  hqGamesCompletePath: PropTypes.string.isRequired,
  phrases: phrasesType.isRequired,
};

export default PlayableGames;
